export const COACH_SAVE = '/coach/contest/coach/save'                   // 教练修改保存

export const ADMIN_LOGIN = '/coach/admin/coach/login'                         // 用户登录

export const ADMIN_LOGOUT = '/coach/admin/logout'                         // 用户退出

export const ADMIN_GRAPHCODE = '/coach/admin/graphcode'                 // 用户验证码图片

export const TEAM_ENTER_LIST =  '/coach/contest/usadp/team/enterList'    // USADP组队报名信息查询

export const USADP_TEAM_FILE =  '/coach/contest/usadp/team/saveFile'         // USADP组队信息查询

export const USADP_TEAM_SAVE =  '/coach/contest/usadp/team/saveTeam'         // USADP组队保存

export const USADP_TEAM_CACEL =  '/coach/contest/usadp/team/cacelTeam'         // USADP解散团队

export const USADP_TEAM_LIST =  '/coach/contest/usadp/team/list'         // USADP组队信息查询

export const USADP_COACH_INFO = '/coach/contest/usadp/team/coach'         // USADP组队获取教练信息

export const SEASON_TASK = '/coach/common/season/task/list'             // 任务列表

export const SEASON_TASK_NEW = '/coach/common/taskList'             // 任务列表

export const SEASON_SEARCH = '/coach/common/task/season/search'             // 任务列表

export const WORK_TASKRELATION = '/coach/work/workTaskRelation'             // 作业任务列表

export const WORK_TASKRELATION_EXPORT = '/coach/work/export'             // 作业任务列表

export const PASSPORT_TEMPLATE_SEARCH = '/coach/passport/template/list'             // 准考证模板列表

export const USADP_COACH_FILE_LIST = '/coach/scienceNotice/list'         // USADP 学术公告列表

export const ENTER_SEARCH = '/coach/contest/enter/search'               // 报名

export const TASK_LIST = '/coach/common/task/taskList'                  // 活动列表接口

export const TASK_PROGRESS_SEARCH = '/coach/task/progress/search'       // 查询任务进度

export const GET_STUDENT_ANALYZE = '/coach/exam/manage/studentAnalyze'  // 考试考生成绩分析

export const MANAGE_LIST = '/coach/exam/manage/list'                    // 考试列表

export const EXPORT_STUDENT = '/coach/exam/manage/exam/export'              // 导出学生成绩分析

export const REPORT_CRRD = '/coach/reportCard/reportCardDetailList'              // 获取成绩报告

export const GET_WORKLIST = '/coach/work/workList'              // 获取作业记录

export const GET_COACH_WORKDERAIL = '/coach/work/workDetail'              // 获取作业记录详情

export const COACH_PASSPORT_LIST = '/coach/passport/list'              // 获取准考证列表

export const COACH_PASSPORT_EXPORT = '/coach/passport/exportPassport'              // 导出准考证列表

export const EXTRA_INFO = '/coach/contest/coach/extraInfo'              // 获取额外信息

export const FILE_UPLOAD = '/coach/file/upload'                        // 获取额外信息

export const COACH_UPDATE = '/coach/contest/coach/update'              // 获取额外信息

export const COACH_JUMP = '/coach/admin/coachJump'                     // 跳转过来登录

export const COACH_CHANGE_SEASON = '/coach/contest/coach/changeSeason'     // 切换活动

export const COACH_JUMP_USER = '/coach/admin/coach/jumpUser'           // 获取跳转参数

export const TEAM_LIST = '/coach/contest/team/list'                    // 获取组队列表

export const COMMON_API_GET_FILE = '/api/file/getFile'                // 获取阿里云文件

export const USADP_COACH_FILE_INFO = '/coach/scienceNotice/info'        // USADP 学术公告详情

export const UPDATEPASSWORD = '/coach/admin/updatePassword'            // 修改密码

export const CURRICULAPLAN_LIST = '/coach/curriculaPlan/list'            // 课程列表

export const CURRICULAPLAN_DETAIL = '/coach/curriculaPlan/detail'         // 课程详情

export const CURRICULAPLAN_SITUATION = '/coach/curriculaPlan/situation'   // 课程小节进度提交

export const CURRICULAPLAN_INFO = '/coach/curriculaPlan/curriculaInfo'            // 课程小节进度提交

export const CURRICULAPLAN_CERTIFICATE = '/coach/contest/certificate/placeholderList'            // 查看证书

export const CERTIFICATE_LIST = '/coach/contest/certificate/list'      // 认证证书列表

export const CERTIFICATE_CREATE = '/coach/contest/certificate/create'     // 证书制作

export const TEST_GET_QUESTIONS = '/coach/exam/practice/getQuestions'       // 练习试题列表获取

export const TEST_SAVE_ANSWERS = '/coach/exam/practice/saveAnswers'         // 练习提交答案

export const TEST_ANALYZE = '/coach/exam/practice/analyze'                   // 练习成绩报告

export const TEST_REPORT = '/coach/exam/practice/report'                     // 练习分析

export const TEST_RESTART = '/coach/exam/practice/restart'                    // 练习再来一次

export const TEST_SITUATION = '/coach/exam/practice/handExercise'                // 课程小节进度提交

export const CERTIFICATE_CONTENT = '/coach/contest/certificate/content'       // 查看证书

export const ENTER_TEAMDATA_LIST = '/coach/contest/enter/teamData/list'                         // 查询视频链接接口

export const ENTER_TEAMDATA_EXPORT = '/coach/contest/enter/teamData/export'      // 查询视频链接接口

export const FILE_GETFILE = '/coach/file/getFile'                             // 查询视频链接接口

export const CONTEST_ENTER_PAIDUSERS = '/coach/contest/enter/paidUsers'                             // 查询视频链接接口



// WEBPACK FOOTER //
// ./src/assets/js/api-constant.js